import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  returnRateFromModel,
  validateReturnRateCondition,
  type ReturnRateState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const RETURN_RATE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnRateState>>,
): ConditionType<ReturnRateState, Condition.ReturnRate> => ({
  name: "Customer return rate",
  description(state) {
    if (!state.comparison) {
      return "The percentage of orders this customer has returned";
    }
    return `Customer return rate ${state.comparison.toLowerCase()} ${state.returnRate}`;
  },
  Details(props: ConditionTypeDetailsProps<ReturnRateState>) {
    return React.createElement(Details, props);
  },
  empty: { returnRate: "0", comparison: null },
  fromModel(model) {
    return returnRateFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.RETURN_RATE,
      // Store as decimal
      returnRate: +state.returnRate / 100,
      comparison: state.comparison,
    };
  },
  valid(state) {
    return validateReturnRateCondition(state).valid;
  },
});

export { type ReturnRateState } from "@redotech/redo-model/return-flow/condition-validate";
